import React, { forwardRef, useContext } from 'react';
import { useFormContext } from 'react-hook-form';

import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import FormControl from 'react-bootstrap/FormControl';
import FormLabel from 'react-bootstrap/FormLabel';

import { NCRContext } from "views";

import { get, set } from "lodash";

const TextArea = forwardRef(({
  callBackFunction, error, label, name,
  placeholder, disabled, height, className
}, ref) => {

  const { state, setState } = useContext(NCRContext);
  const { errors } = useFormContext();

  const defaultValue = get(state, name) || '';
  const defaultError = get(errors, name);
  const defaultCallback = (value) => setState(state => ({ ...set(state, name, value) }));

  const err = error || defaultError;
  const callback = callBackFunction || defaultCallback;

  return (
    <>
      <Row className={'mb-2'}>
        <Col className={'my-auto'}>
          <FormLabel className={'my-auto'}>{`${label}:`}</FormLabel>
        </Col>
        <Col xs={1}>
          <FormControl className='invisible' />
        </Col>
      </Row>
      <Row className={'mb-2'}>
        <Col>
          <FormControl
            name={name}
            as='textarea'
            ref={ref}
            placeholder={placeholder}
            defaultValue={defaultValue}
            onChange={({ target: { value } }) => (callback(value))}
            disabled={disabled}
            rows={height ? height : 3}
            className={
              (err ? 'error ' : '') +
              (disabled ? 'read-only ' : 'general-input ') +
              (className ? className : '')
            }
          />
        </Col>
      </Row>
    </>
  )
});

export { TextArea };
